import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getCalendarCountries, getWorkTypes } from './api';

export const path = '/calendar';

const PageCalendar: React.FC = (props) => {
  const Calendar = Loadable.Map({
    loader: {
      page: () => import('./page'),
      workTypes: getWorkTypes,
      // без справочника стран страница работает как раньше — по календарю по умолчанию
      countries: () => getCalendarCountries().catch(() => []),
    },
    loading: LoadableLoading,
    render(loaded, loadedProps) {
      const Page = loaded.page.default;

      return <Page {...loaded} {...loadedProps} />;
    },
  });

  return <Calendar {...props} />;
};

export default PageCalendar;
